const fa = {
    accepted: 'فیلد :attribute می بایست تایید شود',
    alpha: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی باشد',
    alpha_dash: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی و خط تیره و زیرخط باشد',
    alpha_num: 'فیلد :attribute می بایست فقط شامل حروف و اعداد باشد',
    attributes: {},
    between: 'فیلد :attribute می بایست بزرگتر از :min و کوچکتر از :max باشد',
    confirmed: 'تطبیق فیلد :attribute صحیح نمی باشد',
    email: 'فرمت ایمیل وارد شده در :attribute صحیح نمی‌باشد',
    date: 'تاریخ درج شده در فیلد :attribute صحیح نیست',
    def: 'فیلد :attribute اشکال دارد',
    digits: 'فیلد :attribute می بایست شامل :digits رقم باشد',
    digits_between: ':attribute باید بین :min و :max رقم باشد.',
    different: 'فیلد :attribute می بایست مقداری غیر از :different داشته باشد',
    in: 'فیلد :attribute انتخاب شده صحیح نمی باشد',
    integer: 'فیلد :attribute می بایست عددی باشد',
    hex: 'فیلد :attribute باید در فرمت مبنای ۱۶ باشد',
    min: {
        numeric: 'فیلد :attribute می بایست از :min بزرگتر باشد',
        string: 'فیلد :attribute بایستی حداقل :min کاراکتر طول داشته باشد',
    },
    max: {
        numeric: 'فیلد :attribute می بایست از :max کوچکتر باشد',
        string: 'فیلد :attribute نباید بیشتر از :max کاراکتر طول داشته باشد',
    },
    not_in: 'فیلد :attribute انتخاب شده صحیح نمی باشد',
    numeric: 'فیلد :attribute می بایست عددی باشد',
    present: 'The :attribute field must be present (but can be empty).',
    required: 'فیلد :attribute الزامی است',
    required_if: 'در صورت دادن :value به :other تکمیل فیلد :attribute الزامی است',
    same: 'فیلد :attribute می بایست با فیلد :same یکی باشد',
    size: {
        numeric: 'فیلد :attribute می بایست :size باشد',
        string: 'فیلد :attribute می بایست :size کاراکتر طول داشته باشد',
    },
    string: 'فیلد :attribute می بایست متنی باشد',
    url: 'آدرس فیلد :attribute صحیح نمی باشد',
    regex: 'فرمت آدرس :attribute صحیح نمی باشد',
};
export default fa;
